import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'initials',
    standalone: false
})
export class InitialsPipe implements PipeTransform {
    transform(value: string, ...args: any[]): any {
        if (value) {
            const splitValues = value.split(' ');

            let result = '';
            if (splitValues[0]) {
                result = splitValues[0][0];
            }
            if (splitValues[1]) {
                result = result + splitValues[1][0];
            }

            return result;
        }
    }
}
